import { Injectable } from '@angular/core';
import * as process from 'process';

@Injectable({
  providedIn: 'root'
})
export class CLIService {
  public _isCLI(): boolean {
    return typeof process?.pid !== 'undefined';
  }
}
